import { useNavigate } from "react-router-dom";

export default function MovieAndshowsSlider({ title, moviesorshows, genre }) {
  const navigate = useNavigate()

  return (
    <div className="text-white space-y-10 px-4 lg:px-10 z-50 hhh  ">
      <h1 className="text-2xl font-bold ">{title}</h1>
      <div className='flex scrollbar-none  overflow-auto gap-4 lg:gap-8  
                    [&::-webkit-scrollbar]:none
                    [&::-webkit-scrollbar-track]:rounded-full
                    [&::-webkit-scrollbar-track]:bg-gray-100
                    [&::-webkit-scrollbar-thumb]:rounded-full 
                    [&::-webkit-scrollbar-thumb]:bg-gray-300
                    dark:[&::-webkit-scrollbar-track]:bg-[#7300FF10]
                    dark:[&::-webkit-scrollbar-thumb]:bg-[#7300FF]'>
        {moviesorshows.filter(v => v.media_type !== 'person').map((v, i) =>
          <div key={i} className='flex-shrink-0'>
            <button onClick={() => {
              navigate(`/${v?.id}?type=${v?.media_type ? v?.media_type : genre}`)
            }}>
              <img src={v.poster_path ? `https://image.tmdb.org/t/p/w300/${v.poster_path}` : '/posternotFound.jpg'} alt="" className="w-32 md:w-48 rounded-tr-3xl rounded-bl-3xl" />
              <div>
                <h1 className="text-sm md:text-lg w-32 md:w-48 ">{v.title} {v.name}</h1>
                <span className="text-[#7300FF] text-sm">{v.release_date}{v.first_air_date}</span>
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}